/**
 * Utility functions for safely interacting with Chatbase
 */

/**
 * Safely calls a Chatbase method, handling cases where Chatbase may not be loaded
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const chatbase = {
	/**
	 * Close the chat widget
	 */
	close: () => {
		if (typeof window !== "undefined" && window.chatbase) {
			window.chatbase("close");
		}
	},

	/**
	 * Get the current state of Chatbase
	 */
	getState: (): "initialized" | "loading" | "error" | false => {
		if (typeof window !== "undefined" && window.chatbase) {
			return window.chatbase("getState");
		}
		return false;
	},

	/**
	 * Hide the chat widget
	 */
	hide: () => {
		if (typeof window !== "undefined" && window.chatbase) {
			window.chatbase("hide");
		}
	},
	/**
	 * Identify a user with Chatbase
	 */
	identify: (options: { token: string; email?: string; name?: string }) => {
		if (typeof window !== "undefined" && window.chatbase) {
			window.chatbase("identify", options);
		}
	},

	/**
	 * Open the chat widget
	 */
	open: () => {
		if (typeof window !== "undefined" && window.chatbase) {
			window.chatbase("open");
		}
	},

	/**
	 * Reset the current user session
	 */
	resetUser: () => {
		if (typeof window !== "undefined" && window.chatbase) {
			window.chatbase("resetUser");
		}
	},

	/**
	 * Send a message programmatically
	 */
	sendMessage: (message: string) => {
		if (typeof window !== "undefined" && window.chatbase) {
			window.chatbase("sendMessage", message);
		}
	},

	/**
	 * Show the chat widget
	 */
	show: () => {
		if (typeof window !== "undefined" && window.chatbase) {
			window.chatbase("show");
		}
	},

	/**
	 * Toggle the chat widget visibility
	 */
	toggle: () => {
		if (typeof window !== "undefined" && window.chatbase) {
			window.chatbase("toggle");
		}
	},
};
